module.exports = __webpack_public_path__ + "static/media/total_logo.580c8486.png";